import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import {
  Button,
  Chip,
  Collapse,
  Divider,
  Drawer,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Paper,
  Typography,
  Grid
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { NetworkContext } from '../../../../context/NetworkContext';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
      marginTop : theme.spacing(2),
      textAlign : 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  descriptionfield: {
    width: '100%'
   
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));

const BuysellDetails = props => {
  const { open, onClose, onUpdate,usercontent,masters, viewtype, className, ...rest } = props;

  const classes = useStyles();

  const initialValues = {
    languages:['All','Tamil','English','Telugu'],
    title: '',
    price:'',
    description:'',
    address:'',
    imageurl  :'',
    desctelugu:'',
    ismobile : false,
    isemail : false,
    qty : '',
    producttype: {},
    imageurl:'',
    commodity: [],
    subcommodity : {}
  };
  const { sendNetworkRequest } = React.useContext(NetworkContext);

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [subcommodity, setSubcommodity] = useState([]);

  const [values, setValues] = useState({
    ...initialValues

  });
  React.useEffect(() => {
    if(usercontent && usercontent.id)
    {
      setValues({
        ...usercontent
      })

    }
 }, [usercontent]);
  const handleClear = () => {
    setValues({ ...initialValues });
  };



  React.useEffect(() => {
    if(usercontent && usercontent.languages)
    {
      setValues({
        ...usercontent
       
      })
    }
 }, [usercontent]);
  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };

  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };

  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };

  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };

  const handleSubmit = event => {
    event.preventDefault();
    onUpdate && onUpdate(values);
  };

  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];
  const handleChange = type => (event) => {
    setValues({
      ...values,
      [type] : event.target.checked
    })
    //setChecked(event.target.checked);
  };

  const handleoptionchange = type => (event, value) => {
    if(type == 'commodity')
    {
      if(value)
      {
        fetchsubcommodity(value.value)
        
      }else{
        setSubcommodity([])
        setValues(values => ({
          ...values,
          [subcommodity]: null
        }));
      }
    }
    setValues(values => ({
      ...values,
      [type]: value
    }));
  }

  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
  }
  async function fetchsubcommodity(commodityID)
  {
    let bodycontent = {
      commodityID
    }

    let commodity_arr = await sendNetworkRequest('/fetchsubcommodity', {}, bodycontent,false)
    setSubcommodity(commodity_arr)
  }
  return (
  <Paper className={classes.papercontent}> 
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        
        <div className={classes.content}>
          <Grid container xs={12} spacing={2}>
         
          <Grid item xs={12}>
            <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters.commodity}
                  margin="dense"
                  fullWidth
                  disabled={viewtype == 2 ? true : false}
                  onChange={handleoptionchange('commodity')}
                  value={values.commodity}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label={"Commodity"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid>
                    <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            onChange={handleinputchange('title')}
                            value={values.title}
                           label="Title"
                          />
                      </Grid>
                      <Grid container item xs={12} spacing={2}>
                      <Grid item xs={6}>
                          <TextField
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                autoComplete="off"
                                id="vendordeliverydays"
                                name="vendordeliverydays"
                                onChange={handleinputchange('price')}
                                value={values.price}
                              label="Price"
                              />
                              </Grid>
                              <Grid item xs={6}>
                              <Autocomplete
                                    id="combo-box-demo"
                                    options={masters.quantity}
                                    margin="dense"
                                    fullWidth
                                    disabled={viewtype == 2 ? true : false}
                                    onChange={handleoptionchange('priceqty')}
                                    value={values.priceqty}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => <TextField {...params} label={"Quantity"} fullWidth margin="dense" variant="outlined" />}
                                  /> 
                              </Grid>
                      </Grid>
                      <Grid container item xs={12} spacing={2}>
                      <Grid item xs={6}>
                          <TextField
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                autoComplete="off"
                                id="avl_quantity"
                                name="avl_quantity"
                                onChange={handleinputchange('qty')}
                                value={values.qty}
                              label="Available Quantity"
                              />
                              </Grid>
                              <Grid item xs={6}>
                              <Autocomplete
                                    id="combo-box-demo"
                                    options={masters.quantity}
                                    margin="dense"
                                    fullWidth
                                    disabled={viewtype == 2 ? true : false}
                                    onChange={handleoptionchange('avlquantity')}
                                    value={values.avlquantity}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => <TextField {...params} label={"Quantity"} fullWidth margin="dense" variant="outlined" />}
                                  /> 
                              </Grid>
                      </Grid> 
                             
                  <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={viewtype == 2 ? true : false}
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            label="Address"
                            onChange={handleinputchange('address')}
                            value={values.address}
                          />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={viewtype == 2 ? true : false}
                            fullWidth
                            autoComplete="off"
                            id="city"
                            name="city"
                            label="City"
                            onChange={handleinputchange('city')}
                            value={values.city}
                          />
                    </Grid>
                   
                    <Grid item xs={12}>
                       
                       <TextField
                             variant="outlined"
                             margin="dense"
                             disabled={viewtype == 2 ? true : false}
                             fullWidth
                             rowsMin={3}
                             rowsMin={3}
                             rows={3}
                             
                             autoComplete="off"
                             id="vendordeliverydays"
                             name="vendordeliverydays"
                             label="Description"
                             onChange={handleinputchange('description')}
                             value={values.description}
                           />
                         </Grid>  
                         <Grid item xs={12}>
                       
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={viewtype == 2 ? true : false}
                            fullWidth
                            rowsMin={3}
                            rowsMin={3}
                            rows={3}
                            
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            label="Terms & Condition"
                            onChange={handleinputchange('description')}
                            value={values.description}
                          />
                        </Grid>  
                    <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Image Url"
                           disabled={viewtype == 2 ? true : false}
                           onChange={handleinputchange('imageurl')}
                           value={values.imageurl}
                           
                           
                          />
            </Grid>
                    <Grid container item xs={12} textAlign="left">
                    <FormControlLabel
                          value="Email"
                          control={<Checkbox color="primary" 
                          checked={values.isemail}
                          />}
                          label='Email'
                          onChange={handleChange('isemail')}
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value="Mobile"
                          control={<Checkbox color="primary" 
                          checked={values.ismobile}
                          />}
                          label='Mobile'
                          onChange={handleChange('ismobile')}
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value="Whatsapp"
                          control={<Checkbox color="primary" 
                          checked={values.iswhatsapp}
                          />}
                          label='Whatsapp'
                          onChange={handleChange('iswhatsapp')}
                          labelPlacement="end"
                        />
                    </Grid>
                   
                    <Grid container item xs={12} spacing={2}>
                    {values.isemail && <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            onChange={handleinputchange('email')}
                            value={values.email}
                        
                           label="Email"
                          />
                        </Grid>}
                       {values.ismobile &&  <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            onChange={handleinputchange('mobile')}
                            value={values.mobile}
                        
                           label="Mobile"
                          />
                        </Grid> }

                        {values.iswhatsapp &&  <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            onChange={handleinputchange('whatsapp')}
                            value={values.whatsapp}
                        
                           label="Whatsapp"
                          />
                        </Grid> }
                      </Grid>
           
            
            
          </Grid>
         
        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            Update
          </Button>
        </div>
      </form>
      </Paper> 
  );
};

BuysellDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default BuysellDetails;
